import React, { useEffect, useState } from "react";
import { Button, Card, Select, Form, notification } from "antd";
import { GroupMeterGrid } from "../../../../../Common/UIConstants";

import { CONFIGURATION_GROUP_METER_CONFIG, Messages } from "../../../../../Common/Constants";
import { useLocation, useNavigate, useParams } from "react-router-dom";

import { useSelector } from "react-redux";
import { useStoreUpdaterWithAPI } from "../../../../../Hooks/UseStoreUpdaterWithApi";
import { APIConstants } from "../../../../../Common/APIConstants";
import { CONFIGURATION_GROUP_METER } from "../../../../../Common/Constants";
import GroupMeterPopup from "../../../../CommonScreens/CreateGroupMeter";

const GroupMeterConfig = () => {
  const { makeRequest, loading, isSaving } = useStoreUpdaterWithAPI();
  const navigate = useNavigate();

  const [isAdd, setIsAdd] = useState(false);
  const [isUpdate, setIsUpdate] = useState(false);
  

  const [selectedDeleteData, setSelectedDeleteData] = useState({});
  const [selectedGroupNameID, setSelectedGroupNameID] = useState(22);
  const [selectedConverterID, setSelectedConverterID] = useState(24);
  const [meterNameList, setMeterNameList] = useState([]);
  const [isSearchClicked, setIsSearchClicked] = useState(false);
  const [filteredData, setFilteredData] = useState();
  const [skip, setSkip] = useState(true);
  const [flowGroupList, setFlowGroupList] = useState([]);
  const [flowSubGroupList, setFlowSubGroupList] = useState([]);
  const [flowGroupMeterList, setFlowGroupMeterList] = useState([]);
  const [groupMeterNameList, setGroupMeterNameList] = useState([]);
  const [calculationTypeList, setCalculationTypeList] = useState([]);
  const [uspList, setUspList] = useState([]);
  const [updateRecord, setUpdateRecord] = useState([]);



  const mode = useSelector((state) => state.darkMode);

  const { isdarkMode } = mode;
  //flowgrouplist for handleserach and popup add
  const [form] = Form.useForm();


  useEffect(() => {
    if (location.pathname.includes(`${CONFIGURATION_GROUP_METER}/group-meter-add-popup`)) {
      setIsAdd(true);
      setIsUpdate(false);
      form.resetFields();
    } else if (location.pathname.includes(`${CONFIGURATION_GROUP_METER}/group-meter-update-popup`)) {
      setIsUpdate(true);
      setIsAdd(false);
    } else {
      setIsAdd(false);
      setIsUpdate(false);
    }
  }, [location.pathname]);

  useEffect(() => {
    makeRequest({
      type: APIConstants.GET,
      url: APIConstants.GET_FLOW_GROUP_DETAILS,
      
    }).then((res) => {
      // onClose();
      setFlowGroupList(res);
    
    });

    makeRequest({
      type: APIConstants.GET,

      url: `${APIConstants.GET_FLOW_SUB_GROUPS_DETAILS}?GroupID=${selectedGroupNameID}`,

    }).then((res) => {
      setFlowSubGroupList(res);
       
    });

  


    makeRequest({
      type: APIConstants.GET,
      url: APIConstants.GET_CALCULATION_TYPE_MASTER_DETAILS,
      // data: reportStatusResData,
      // successMessage: Messages.FETCH_DATA,
    }).then((res) => {
      setCalculationTypeList(res);
      // console.log(calculationTypeList);
    });

    makeRequest({
      type: APIConstants.GET,
      url: APIConstants.USP_LIST_SITES,
    }).then((res) => {
      setUspList(res);
      // console.log(uspList);
    });
  }, []);


  //table dropdown groupID is set
  const handleGroupNameChange = (changedValue) => {
    // console.log(changedValue)
    setSelectedGroupNameID(Number(changedValue));
    setIsSearchClicked(false);
    // dont log selectedGroupNameID here it is not immediatly updated
  };

  useEffect(() => {
    // After 1 second, set skipValue to false
    const timeoutId = setTimeout(() => {
      setSkip(false);
    }, 2000);

    // Clear the timeout if the component unmounts or skipValue is set to false
    return () => clearTimeout(timeoutId);
  }, []);


  const handleClear = () => {
    form.resetFields();
  };

  const handleSearchClick = () => {
    
    makeRequest({
      type: APIConstants.GET,
      url: `${APIConstants.GET_FLOW_GROUP_METER_DETAILS}?GroupID=${selectedGroupNameID}`,
    }).then((res) => {
      setFlowGroupMeterList(res);
      setIsSearchClicked(true);

      
    });
  };


  const fetchFlowGroupMeterList = () => {
    makeRequest({
      type: APIConstants.GET,
      url: APIConstants.GET_FLOW_GROUP_METER_DETAILS,
    })
      .then((res) => {
        setFlowGroupMeterList(res);
        console.log(res)
      })
      .catch((err) => {
        console.error("Error fetching flow group meter list:", err);
      });
  };
  

  //based on selection in dropdown the table data is fetched
  useEffect(() => {
    if (isSearchClicked) {
      const filtered = flowGroupMeterList?.filter(
        (item) => Number(item.groupID) === selectedGroupNameID
      );
      setFilteredData(filtered);
    } else {
      setFilteredData([]); // Clear filtered data if not searched
    }
  }, [isSearchClicked, selectedGroupNameID, flowGroupMeterList]); // Update on change



  const handleNotification = (msg) => {
    notification.open({
      message: `${msg}`,
    });
  };

  
  const handleAddPopup = () => {
    setIsAdd(!isAdd);
    // handleClear();
    navigate(`${CONFIGURATION_GROUP_METER}/group-meter-add-popup`);
  };



  const handleUpdatePopup =  (record) => {
    setIsUpdate(!isUpdate);
    // const selectedRowObj = record;
    navigate(`${CONFIGURATION_GROUP_METER}/group-meter-update-popup`);
    setUpdateRecord(record)
    // console.log(record)
   
  };

  const handleDeletePopup = (record) => {
    setSelectedDeleteData({
      GroupMeterDetailID: Number(record?.groupMeterDetailID),
    });
  };

  const handleDeleteSubmit = async (groupMeterDetailID) => {
    try {
      
      makeRequest({
        type: APIConstants.DELETE,
        url: `${APIConstants.DELETE_FLOW_GROUP_METER_DETAILS}?GroupMeterDetailID=${groupMeterDetailID}`,
       
      });

      const updatedFlowGroupMeterList = flowGroupMeterList.filter(
        (item) => item.groupMeterDetailID !== groupMeterDetailID
      );

      setFlowGroupMeterList(updatedFlowGroupMeterList);

      handleNotification("Successfully Deleted");
      handleClear();
      // flowGroupMeterRefetch();
    } catch (err) {
      console.log(err);
    }
  };





  
  

  return (
    <div>
      <Card className={`w-full h-auto dark ${isdarkMode ? 'darkmode border-0' : 'whitemode'} `}>
        <div className="flex justify-between">
          <div className="flex space-x-2">
          <p className={`ml-2 mt-1 dark ${isdarkMode ? 'darkfont' : 'whitemode'} `}>Select Module:</p>
            <Select dropdownClassName={isdarkMode ? 'select-dropdown-background ' : 'light-mode-dropdown'}
              placeholder="Select Module"
           
              className={`w-auto  ${isdarkMode ? 'custom-table-subgroup-dropdown ' : 'whitemode'} `}
              onChange={handleGroupNameChange} //change to module list later
            >
              {flowGroupList?.map((item) => (
                <Select.Option key={item?.groupID} value={item?.groupID}>
                  {item?.groupName}
                </Select.Option>
              ))}
            </Select>
          <p className={`ml-2 mt-1 dark ${isdarkMode ? 'darkfont' : 'whitemode'} `}>Select Group:</p>
            <Select dropdownClassName={isdarkMode ? 'select-dropdown-background ' : 'light-mode-dropdown'}
              placeholder="Select Group"
              // className="w-auto"
              className={`w-auto  ${isdarkMode ? 'custom-table-subgroup-dropdown ' : 'whitemode'} `}
              onChange={handleGroupNameChange}
            >
              {flowGroupList?.map((item) => (
                <Select.Option key={item?.groupID} value={item?.groupID}>
                  {item?.groupName}
                </Select.Option>
              ))}
            </Select>
            <Button className="blue-btn" onClick={handleSearchClick}>
                Search
              </Button>
          </div>
          

          <Button onClick={handleAddPopup} className="blue-btn mb-2">
            Add Group Meter
          </Button>
        </div>

        <GroupMeterPopup
         isAdd={isAdd}
          setIsAdd={setIsAdd}
          flowGroupList={flowGroupList}
          selectedConverterID={selectedConverterID}
          setSelectedConverterID={setSelectedConverterID} 
          uspList={uspList}
          calculationTypeList={calculationTypeList}
          updateRecord={updateRecord}
          isUpdate={isUpdate}
          setIsUpdate={setIsUpdate}
          fetchFlowGroupMeterList={fetchFlowGroupMeterList}
          flowGroupMeterList={flowGroupMeterList}
          title={"Group Meter Details"}
         
          
        />
        

       

<GroupMeterGrid
          handleUpdatePopup={handleUpdatePopup}
          handleDeletePopup={handleDeletePopup}
          handleDeleteSubmit={handleDeleteSubmit}
          flowGroupMeterList={filteredData}
          flowSubGroupList={flowSubGroupList}
          uspList={uspList}
        />
    
        
      </Card>
    </div>
  );
};
export default GroupMeterConfig;



